export const linkPrefix = () => {
    const env = process.env.REACT_APP_NODE_ENV;
    return env === 'prod' ? '' : 'dev';
}

// WordPress marketing home the Catalight logo links to, and where a zero-permission user is bounced
// (BHPNPP-3108 #6). Per-env via REACT_APP_WORDPRESS_HOME_URL — replaces the old binary linkPrefix()
// build for the logo, which mapped every non-prod env to `providersdev`. The base .env carries a
// default so a missing per-env override degrades to a real URL, never `undefined`; the code fallback
// (prod home) is a last-resort belt-and-suspenders. (linkPrefix() still backs the footer links.)
export const WORDPRESS_HOME_URL = process.env.REACT_APP_WORDPRESS_HOME_URL ?? 'https://providers.catalight.org/';

export const oktaAppByUrl = (url: string) => {
    if (url.includes('eum')) {
        return 'UM';
    }
    return 'CP';
};